import { UserService } from 'src/app/services/user.service';
import { MatBottomSheet } from '@angular/material';
import { TakePhotoComponent } from './takePhoto/takePhoto.component';
var PerfilComponent = /** @class */ (function () {
    function PerfilComponent(_userService, bottomSheet) {
        this._userService = _userService;
        this.bottomSheet = bottomSheet;
        this.edit = false;
        this.identity = sessionStorage.getItem("identity-domCloud");
    }
    PerfilComponent.prototype.ngDoCheck = function () {
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
    };
    PerfilComponent.prototype.updateProfile = function () {
    };
    PerfilComponent.prototype.updatePhoto = function () {
        this.bottomSheet.open(TakePhotoComponent);
    };
    return PerfilComponent;
}());
export { PerfilComponent };
